import * as api from '../../api/api'
import { activityNewList, activityDetail } from '../../api/activity'
const state = {
  activities: null,
  activitiespaged: null,
  news: null,
  newpaged: null,
  activityInfo: null,
}

// mutations
const mutations = {
  saveHomeArticleList(state, data) {
    state.news = data.articles//新闻
    state.newpaged = data.paged
  },
  saveHomeActivityList(state, data) {
    state.activities = data.activities//活动
    state.activitiespaged = data.paged
  },

  saveHomeActivityInfo(state, data) {
    state.activityInfo = data
  },
}

// actions
const actions = {
  fetchHomeArticleList({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      let params = {
        id: params.id,
        page: params.page,
        per_page: params.per_page
      }
      api.articleList(params).then(
        (response) => {
          if (response) {
            commit('saveHomeArticleList', response)
          }
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  },

  fetchHomeActivityList({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      let params = {
        id: params.id,
        page: params.page,
        per_page: params.per_page
      }
      activityNewList(params).then(
        (response) => {
          if (response) {
            commit('saveHomeActivityList', response)
          }
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  },

  fetchHomeActivityInfo({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      let params = {
        activity: params.id
      }
      activityDetail(params).then(
        (response) => {
          if (response) {
            commit('saveHomeActivityInfo', response)
          }
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js